"use client"
import React from 'react'
import Navbar from '../../components/client/common/Navbar'
import MainPayment from "../../components/client/Applications/Payment/MainPayment"

const Payment = () => {
  const user = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}")
    } catch {
      return {}
    }
  }, [])
  const isClient = user?.role === "client"

  return (
    <div className="min-h-screen">
      {isClient && <Navbar />}
      <main className="p-8">
       <MainPayment/>
      </main>
    </div>
  )
}

export default Payment
